import { atom } from "jotai";

export type SiteEmissionSortField = "emission_count" | "emission_sum";

export const siteEmissionSortFieldAtom =
    atom<SiteEmissionSortField>("emission_count");
